import {Component, OnInit} from '@angular/core';
import {CrudService} from "@core/shared/services/crud.service";
import {CrudAction} from "@core/shared/models/crud";

@Component({
    selector: 'app-core-page-channel-update',
    templateUrl: './page-channel-update.component.html',
    styleUrls: ['./page-channel-update.component.scss'],
    providers: [
        CrudService
    ],
    standalone: false
})
export class PageChannelUpdateComponent implements OnInit {

    constructor(
        private _crudService: CrudService
    ) {}

    ngOnInit() {

        this._crudService.setAction(CrudAction.Update);
    }
}
